import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { ExternalLink } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;
const FULL_LOGO = `${API}/api/uploads/navanaa_logo_clean.png`;

const resolveUrl = (src) => (src && src.startsWith('/') ? `${API}${src}` : src);

export default function ProjectsPage() {
  const [projects, setProjects] = useState([]);

  const fetchProjects = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/api/projects`);
      setProjects(res.data);
    } catch (_e) { /* network error */ }
  }, []);

  useEffect(() => { fetchProjects(); }, [fetchProjects]);

  return (
    <>
      <nav className="nv-nav scrolled" data-testid="nav" style={{ background: 'rgba(249,246,241,.97)', backdropFilter: 'blur(24px)', padding: '18px 72px', boxShadow: '0 1px 0 rgba(212,168,75,.15)' }}>
        <Link to="/" className="nv-logo" style={{ textDecoration: 'none' }}>
          <img src={FULL_LOGO} alt="Navanaa Estate" className="nv-logo-img" style={{ filter: 'none' }} />
        </Link>
        <div className="nv-nav-links-wrap">
          <ul className="nv-links">
            <li><Link to="/" style={{ color: 'var(--text-mid)', textDecoration: 'none', fontSize: 10, fontWeight: 500, letterSpacing: '.24em', textTransform: 'uppercase' }}>Home</Link></li>
            <li><Link to="/projects" style={{ color: 'var(--gold)', textDecoration: 'none', fontSize: 10, fontWeight: 500, letterSpacing: '.24em', textTransform: 'uppercase' }}>Projects</Link></li>
          </ul>
        </div>
        <Link to="/" className="nv-nav-cta" style={{ borderColor: 'var(--indigo)', color: 'var(--indigo)', textDecoration: 'none' }}>Back to Estate</Link>
      </nav>

      <div className="nv-projects-page" data-testid="projects-page">
        <div className="nv-section-inner">
          <div className="nv-eyebrow" style={{ justifyContent: 'center' }}>Our Ventures</div>
          <h2 className="nv-h2 dark" style={{ textAlign: 'center' }}>Our <em>Projects</em></h2>
          <p className="nv-body" style={{ textAlign: 'center', margin: '0 auto' }}>
            A portfolio of purpose-driven ventures by the founders — from organic food to sustainable real estate and social impact.
          </p>
          <div className="nv-projects-grid" data-testid="projects-grid">
            {projects.map((p) => (
              <div className="nv-project-card" key={p.id || p.name}>
                <div className="nv-project-card-img">
                  {p.image_url ? <img src={resolveUrl(p.image_url)} alt={p.name} /> : <span>{p.name}</span>}
                </div>
                <div className="nv-project-card-body">
                  {p.category && <div className="nv-project-cat">{p.category}</div>}
                  <h3>{p.name}</h3>
                  <p>{p.description}</p>
                  {p.link && (
                    <a href={p.link} target={p.link.startsWith('/') ? '_self' : '_blank'} rel="noopener noreferrer" className="nv-project-link">
                      {p.link.startsWith('/') ? 'View Project' : 'Visit Website'} <ExternalLink size={12} />
                    </a>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="nv-footer-bottom" style={{ background: 'var(--warm-dark)' }}>
        <p>&copy; 2025 Navanaa Estate. All rights reserved.</p>
        <p>Crafting Timeless Himalayan Living.</p>
      </div>
    </>
  );
}
